const AppConfig = {
  key: {
    LoggedIn: 'loggedInManageLottokey'
  }
}

export default AppConfig;
